export var KitDisplayType;
(function (KitDisplayType) {
    KitDisplayType[KitDisplayType["INDIVIDUAL"] = 1] = "INDIVIDUAL";
    KitDisplayType[KitDisplayType["GROUPED"] = 2] = "GROUPED";
})(KitDisplayType || (KitDisplayType = {}));
//# sourceMappingURL=kit-display-type.js.map